import { observer } from "mobx-react-lite";
import { Button, Header, Label, Segment } from "semantic-ui-react";
import axios from 'axios';

import { Form, Formik, Field, useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import ReactToPrint from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import MyTextInput, { MyTextInputConvD, MyTextInputConv, MyTextAreatConv, MyTextInputFechas } from "../../../app/common/form/MyTextInput";

import { calculoFechas } from "../../Portafolio/helpers/calculoFechas";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import "../src/css/convenios.css";
import { MySelectInputControl } from "../../../app/common/form/MySelectInput";

interface IFileData {
  file: any;
  name: string;
  type: string;
  description: string;
}

interface IFormData {
  id: number;
  ContentType: string;
  files: IFileData[];
}

interface Cuenta {
  saldoInicial: number;
  saldoActual: number;
}

let inicial: number,
  actual: number,
  total: number,
  data: any;

export default observer(function ModalFinancieroPago(
  CO: {
    id: number,
    show: any,
    onHide: any,
    ctype: any,
    conv: string,
    monto: number,
    entidadid: number

  }) {

  const apiFiURL = process.env.REACT_APP_API_URL + `/Storage`;
  const apiURL = process.env.REACT_APP_API_URL + `/CATConvenios/ApplyPayment`;
  const urlc = process.env.REACT_APP_API_URL + `/CCTCuentas/SGEntidades/${CO.entidadid}/${CO.conv}`;

  const [file, setFile] = useState<File | null>(null);
  const [description, setDescription] = useState("");
  const [formData, setFormData] = useState<IFormData>({ id: +CO.id, files: [], ContentType: CO.ctype });
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const [saldoInicial, setSaldoInicial] = useState<number>(0);
  const [saldoActual, setSaldoActual] = useState<number>(0);
  const [resultado, setResultado] = useState<number>(0);

  const initialValues = {
    amountCUR: 0,
    convenio: CO.id,
    monto: 0,
    n63A: 0,
    numberCUR: 0,
    descriptionCUR: '',
    generatedCUR: ''
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(urlc);
      const data = await response.json();

      const saldoInicial = Number(data[0].saldoInicial); 
      const saldoActual = Number(data[0].saldoActual);

      setSaldoInicial(saldoInicial);
      setSaldoActual(saldoActual);

      const calculatedResult = saldoInicial - saldoActual;
      setResultado(calculatedResult);

    } catch (error) {
      console.error('Error al obtener los datos:', error);
    }
  };

  const handleSubmit = (values: any) => {
    axios.post(apiURL, values)
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.log(error);
      }
      );
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSelectedFiles([...selectedFiles, event.target.files[0]]);
      setFile(event.target.files[0]);
    }
  };

  const handleDescriptionChanges = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setDescription(event.target.value);
  };

  const handleSubmitf = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (file && description) {
      const fileData: IFileData = {
        file: file,
        name: file.name,
        type: file.type,
        description,
      };
      setFormData({
        ...formData,
        files: [...formData.files, fileData],
      });
      setDescription("");
      setFile(null);
    }
  };

  const handleSend = () => {
    const formDataToSend = new FormData();
    formDataToSend.append("id", CO.id.toString());
    formDataToSend.append("ContentType", CO.ctype);
    formData.files.forEach((fileData, index) => {
      formDataToSend.append(`Files[${index}].File`, fileData.file);
      formDataToSend.append(
        `Files[${index}].Description`,
        fileData.description
      );
    });
    fetch(apiFiURL, {
      method: "POST",
      body: formDataToSend,
    }).then(function (r) {
      if (r.status == 200) {
        return ExitValf()
      } else { ExitMsjErrorf() }
    });
  };

  function ExitValf() {
    Swal.fire({
      position: "center",
      showCloseButton: true,
      title: 'Pago aceptado',
      text: "El pago se ha registrado satisfactoriamente",
      icon: 'success',

      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonAriaLabel: "confirm-button",

    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      } else if (result.isDismissed) {
      }
    })
  };

  function ExitMsjErrorf() {
    Swal.fire({
      position: "center",
      icon: "warning",
      title: "Error",
      text: 'Ha ocurrido un error en la actualización, por favor verifica que la informacion sea correcta e intenta de nuevo.',
      showConfirmButton: false,
      timer: 3500,
    });
  };

  const validationSchema = Yup.object().shape({
    monto: Yup.number()
      .min(0, 'El número debe ser mayor o igual a cero')
      .max(saldoInicial, `El número no debe ser mayor a ${saldoInicial}`)
      .max(saldoActual, `El número no debe ser mayor a ${saldoActual}`)
      .required('Este campo es requerido'),
  });

  return (
    <>

      <Modal
        {...CO}
        size="lg"
        className="modal-add-dep-content"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Aplicar pago del código: {CO.conv}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Container className="modal-sol-detalle form-area">

            <Row className="cuenta-datos-modal"> 
              <Col className="cuenta-saldo-inicial">
                <p>Saldo Inicial del código:<br /><span>Q. {saldoInicial !== null ? saldoInicial : 'Cargando...'}</span></p>
              </Col>

              <Col className="cuenta-saldo-actual">
                <p>Saldo Actual:<br /><span>Q. {saldoActual !== null ? saldoActual : 'Cargando...'}</span></p>
              </Col>
            </Row>

            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={validationSchema}                
            >
              {({ isSubmitting }) => (
                <Form className="form-content pago-conv-form">

                  <MyTextInputConv
                    name="n63A"
                    label="Ingresa el número del formulario 63A:"
                    type="number"
                    id="n63A"
                    placeholder={"0000"}
                  />

                  <MyTextInputConv
                    name="numberCUR"
                    label="Ingresa el número del CUR"
                    type="number"
                    id="numberCUR"
                    placeholder={"0000"}
                  />

                  <MyTextInputFechas
                    label="Fecha de generación del CUR"
                    placeholder=""
                    id="generatedCUR"
                    name="generatedCUR"
                    onFocus={(e: any) => (e.currentTarget.type = "date")}
                    onBlur={(e: any) => (e.currentTarget.type = "date")}
                  />

                  <MyTextInputConv
                    name="monto"
                    label="Ingresa el monto del pago"
                    type="number"
                    id="monto"
                    placeholder="000"
                  />

                  <MyTextAreatConv
                    name="descriptionCUR"
                    label="Ingresa la descripción del CUR"
                    type="textarea"
                    id="descriptionCUR"
                    placeholder="Descripción"
                  />

                  <Row className="form-pago-buttons-area">
                    <Button
                      disabled={isSubmitting}
                      variant="primary"
                      type="submit"
                    >
                      Aplicar pago
                    </Button>
                  </Row>
                </Form>
              )}
            </Formik>

          </Container>

        </Modal.Body>

      </Modal>

    </>
  );
})